<template>
  <slot></slot>

    <modal :id="modalId" @shown="init">

      <template v-slot:header>
        <h4 class="modal-title">Add Adjusters</h4>
      </template>

        <form id="add-adjusters" method="POST" :action="action">
          <input type="hidden" name="_token" :value="$csrf_token">
          <input type="hidden" name="_method" value="PATCH">
          <input v-for="adjuster in adjusters" name="adjuster_ids[]" type="hidden" :value="adjuster.id">

          <adjuster-typeahead @adjusterSelected="addAdjuster"></adjuster-typeahead>

          <table class="table table-striped table-hover mt-2 mb-0">
            <tbody>
            <tr v-for="(adjuster, index) in adjusters">
              <td>
                {{ index + 1 }}
              </td>
              <td>
                {{adjuster.first_name}} {{adjuster.last_name}}
                <template v-if="(adjuster.email !== '')">/&nbsp;{{ adjuster.email }}</template>
                <template v-if="(adjuster.phone !== '')">&nbsp;/&nbsp;{{ adjuster.phone }}</template>
              </td>
              <td class="text-right">
                <a href="#" class="btn btn-sm btn-outline-secondary py-0" @click.prevent="removeAdjuster(adjuster.id)"><i class="fa fa-fw fa-user-times"></i></a>
              </td>
            </tr>
            </tbody>
          </table>

        </form>

      <template v-slot:footer>
        <button type="button" class="btn btn-white" @click="hideModal"><i class="fa fa-fw fa-ban"></i> Close</button>
        <button type="submit" form="add-adjusters" class="btn btn-primary" :disabled="adjusters.length === 0"><i class="fa fa-fw fa-user-plus"></i> Add</button>
      </template>

    </modal>
</template>

<script>
  import HasModal from "../mixins/HasModal";
  import AdjusterTypeahead from "../AdjusterTypeahead.vue";

  export default {
    mixins: [HasModal],

    components: {AdjusterTypeahead},

    props: {
      action: {type: String, required: true},
      modalId: {type: String, default: 'smartlistAddAdjusterModal'},
    },

    /**
     * Variables (models).
     */
    data () {
      return {
        adjusters: [],
      }
    },

    /**
     * Computed values
     */
    computed: {
    },

    /**
     * Functions (methods).
     */
    methods: {

      init() {
        this.adjusters = [];
      },

      addAdjuster(newAdjuster) {
        let index = this.adjusters.findIndex(a => a.id === newAdjuster.id);
        if (index === -1) {
          this.adjusters.push(newAdjuster);
        }
      },

      removeAdjuster(idToRemove) {
        this.adjusters = this.adjusters.filter(a => parseInt(a.id) !== parseInt(idToRemove));
      }

    },
  }
</script>
